import { strHash, TEST_USER_HASH } from '@/base/MaUtils.js'
import * as ConfigVars from '@/base/constants/ConfigVars.js'
import { maLogger } from './logger'

function initialize({ userInfo, impersonation }) {
  try {
    // just in case compare hashes for test email
    let skipMsg = null
    if (!userInfo) {
      skipMsg = 'missing user'
    }
    else if (strHash(userInfo.username) === TEST_USER_HASH) {
      skipMsg = 'test user'
    }
    else if (!window?.Beamer) {
      skipMsg = 'beamer not initialized'
    }
    else if (!ConfigVars.production) {
      skipMsg = 'not in prod'
    }
    if (skipMsg) {
      maLogger.info('MaBeamer: skipped ', skipMsg)
      return
    }

    const prefix = impersonation ? `MA-admin:${impersonation}:` : ''
    // if our admins logged in we have to give a different user id so it
    // won't mess up user info on FS
    const userId = `${prefix}${userInfo.userId}`

    window.beamer_config = Object.assign({}, window.beamer_config, {
      user_firstname: userInfo.contactInfo.name || '-',
      user_lastname: userInfo.contactInfo.surname || '-',
      user_email: `${prefix}${userInfo.username}`,
      user_id: userId,
    })

    window.Beamer.init() // call init every time because page DOM might be updated
  }
  catch (e) {
    maLogger.error('MaBeamer: failed to initialize', e)
  }
}

export default {
  initialize,
}
